import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type IFocusEcoleState = {
    students: IParentStudentItem[];
    dataFiltered: IParentStudentItem[];
    fetchingStudents: boolean;
    fetchingEnseignants: boolean;
    choising: boolean;
    etabs: any;
    currentEtab: any;
    enseignants: any;
    anneesScolaires: any;
    enseignantEtabs: any;
    arrayGagnantToPrint: IEnseignantItem[];
    etabsAppelNote: any,
    souscripteurs: any,
    filteredSouscripteurs: any,
    anneesScolairesSouscription: any;
    messages: any;
    listeEtabsSouscrit: any;
    test: any;
    dataListeSouscriptionsFocus: ISouscriptionEtabItem[]; //new
    ListeSouscriptionsFocus:any[]; //Liste des élèves ayant souscrire de 2025-2026 
}


export interface IEnvoieAppel {
    idPersonnel: number;
    nomPersonnel: string;
    prenomPersonnel: string;
    phone1: string;
    phone2: string;
    libelleMatiereCourt: string;
    libelleMatiereLong: string;
    createdAt: string;
    anneeScolaire: string;
    codeEtab: string;
}

export interface ISouscripteur {
    anneeScolaire: string;
    codeEtab: string;
    createdAt: string;
    emailParent: string;
    filiation: string;
    idEleve: number;
    nomPrenomParent: string;
    numeroCellulaire: string;
    professionParent: string;
    residenceParent: string;
    status: number;
    updatedAt: string;
}

export interface IEnvoieNote {
    idEvaluationProgrammation: string;
    idPersonnel: number;
    anneeScolaire: string;
    codeEtab: string;
    libelleMatiereLong: string;
    libelleMatiereCourt: string;
    nomPersonnel: string;
    prenomPersonnel: string;
    phone1: string;
    phone2: string;
    sexe: string;
}

export interface IEnseignantPourTirage {
    idPersonnel: number;
    codeEtab: string;
    nb: number;
    idEvaluationProgrammation: string;
    anneeScolaire: string;
    dateComposition: string; // ISO date string
    libelleMatiereLong: string;
    libelleMatiereCourt: string;
    nomPersonnel: string;
    prenomPersonnel: string;
    phone1: string;
    phone2: string;
    sexe: string; // "M" or "F"
    libelleEtab: string;
    numeroCellulaire: string;
}


export type IIntersectionEnvoieNoteAppel = IEnvoieAppel | IEnvoieNote

export interface IEnseignantItem {
    idPersonnel: number;
    anneeScolaire: string;
    date: string;
    codeEtab: string;
    nomPersonnel: string;
    prenomPersonnel: string;
    phone1: string;
    phone2: string;
    libelleEtab: string;
    libelleMatiereLong: string;
    numOrdre?: number
}

export interface IAnneeScolaireItem {
    anneeScolaire: string;
}

export interface IParentStudentItem {
    anneeScolaire: string;
    codeEtab: string;
    idEleve?: number;
    idClasse?: number;
    matricule: string;
    nomEleve: string;
    prenomEleve: string;
    dateNaissance?: string;
    numeroCellulaire?: string;
    nomPrenomParent?: string;
    filiation?: string;
    photo: string;
    libelleClasseCourt: string;
    libelleClasseLong?: string;
    libEtab: string;
    status: number;
    updatedAt?: any;
    createdAt?: any;
}

export interface ISouscriptionEtabItem {
    anneeScolaire: string;
    codeEtab: string;
    libelleEtab: string;
    nombreTotalSouscriptions: number
    status: number
}

export interface IListeSouscriptionFocusEleve {
    anneeScolaire: string;
    codeEtab: string;
    idEleve: string;
    matricule: string;
    nomEleve: string;
    libEtab: string;
    prenomEleve: string;
    libelleClasseCourt: string;
    libelleEtab: string;
    numeroCellulaire: string;
    dateSouscription: string;
    status: number 
}

export interface IEtab {
    codeEtab: string;
    libEtab: string;
}


const initialState: IFocusEcoleState = {
    students: [],
    dataFiltered: [],
    fetchingStudents: false,
    fetchingEnseignants: false,
    choising: false,
    etabs: [],
    currentEtab: {},
    enseignants: [],
    anneesScolaires: [],
    enseignantEtabs: [],
    arrayGagnantToPrint: [],
    etabsAppelNote: [],
    souscripteurs: [],
    filteredSouscripteurs: [],
    anneesScolairesSouscription: [],
    messages: [],
    listeEtabsSouscrit: [],
    test: [],
    dataListeSouscriptionsFocus: [],
    ListeSouscriptionsFocus: [],
}


export const focusEcoleSlice: any = createSlice({
    name: 'focusEcole',
    initialState,
    reducers: {
        setStudents: (state, action: PayloadAction<IParentStudentItem[]>) => {
            state.students = action.payload
        },
        setTest: (state, action: PayloadAction<any>) => {
            state.test = action.payload
        },

        setdataFiltered: (state, action: PayloadAction<IParentStudentItem[]>) => {
            state.dataFiltered = action.payload
        },

        setFetchingStudents: (state, action: PayloadAction<boolean>) => {
            state.fetchingStudents = action.payload
        },

        setEtabs: (state, action: PayloadAction<any>) => {
            state.etabs = action.payload
        },


        setCurrentEtab: (state, action: PayloadAction<any>) => {
            state.currentEtab = action.payload
        },


        ////////////////////////////   ENSEIGNANT  //////////////////////////////////////
        setFetchingEnseignants: (state, action: PayloadAction<boolean>) => {
            state.fetchingEnseignants = action.payload
        },

        setEnseignants: (state, action: PayloadAction<IEnseignantItem[]>) => {
            state.enseignants = action.payload
        },

        setAnneesScolaires: (state, action: PayloadAction<IAnneeScolaireItem[]>) => {
            state.anneesScolaires = action.payload
        },

        setEnseignantEtabs: (state, action: PayloadAction<any>) => {
            state.enseignantEtabs = action.payload
        },

        setChoising: (state, action: PayloadAction<boolean>) => {
            state.choising = action.payload
        },
        
        addArrayGagnantToPrint: (state, action: PayloadAction<IEnseignantItem>) => {
            state.arrayGagnantToPrint.unshift(action.payload)
        },

        setArrayGagnantToPrint: (state, action: PayloadAction<IEnseignantItem[]>) => {
            state.arrayGagnantToPrint = action.payload
        },

        setEtabsAppelNote: (state, action: PayloadAction<any>) => {
            state.etabsAppelNote = action.payload
        },


        ///////////////////////////////////////////////////////// COMPTE PARENTAL ////////////////////////////////////
        setSouscripteur: (state, action: PayloadAction<ISouscripteur[]>) => {
            state.souscripteurs = action.payload
        },
        setFilteredSouscripteur: (state, action: PayloadAction<ISouscripteur[]>) => {
            state.filteredSouscripteurs = action.payload
        },

        setAnneesScolairesSouscription: (state, action: PayloadAction<any>) => {
            state.anneesScolairesSouscription = action.payload
        },

        setDataListeSouscriptionsFocus: (state, action: PayloadAction<ISouscriptionEtabItem[]>) => {
            state.dataListeSouscriptionsFocus = action.payload
        },

        setListeSouscriptionsFocus: (state, action: PayloadAction<IListeSouscriptionFocusEleve[]>) => {
            state.ListeSouscriptionsFocus = action.payload
        },

        /////////////////////////////////////////////////////// message ///////////////////////////////////
        addMessage: (state, action: PayloadAction<any>) => {
            state.messages = [...action.payload, ...state.messages]
        },

        // setListeEtabsSouscrit: (state, action: PayloadAction<any>) => {
        //     state.listeEtabsSouscrit = action.payload
        // },

        setListeEtabsSouscrit: (state, action: PayloadAction<any>) => {
            state.listeEtabsSouscrit = Array.isArray(action.payload) ? action.payload : [];
        },

        addListeEtabsSouscrit: (state, action: PayloadAction<any>) => {
            const res = [...state.listeEtabsSouscrit]
            state.listeEtabsSouscrit = [action.payload, ...res]
        },

        updateListeEtabsSouscrit: (state, action: PayloadAction<any>) => {
            const res = state.listeEtabsSouscrit.map((item: any) =>
                item.codeEtab === action.payload.codeEtab
                    &&
                    item.anneeScolaire === action.payload.anneeScolaire
                    ? action.payload
                    : item
            )
            state.listeEtabsSouscrit = res
        },
    },
})

export const {
    setStudents,
    setdataFiltered,
    setFetchingStudents,
    setEtabs,
    setCurrentEtab,
    setEnseignants,
    setFilteredEnseignants,
    setFetchingEnseignants,
    setAnneesScolaires,
    setEnseignantEtabs,
    setChoising,
    addArrayGagnantToPrint,
    setArrayGagnantToPrint,
    setEtabsAppelNote,
    setSouscripteur,
    setAnneesScolairesSouscription,
    setFilteredSouscripteur,
    addMessage,
    setListeEtabsSouscrit,
    addListeEtabsSouscrit,
    setTest,
    updateListeEtabsSouscrit,
    setDataListeSouscriptionsFocus, // new
    setListeSouscriptionsFocus
} = focusEcoleSlice.actions

export default focusEcoleSlice.reducer
